import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
const CtaSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    businessType: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);

    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        businessType: ''
      });
      setSubmitted(false);
    }, 3000);
  };
  return <section id="cta" className="bg-knightblack py-20">
      
    </section>;
};
export default CtaSection;